<template>
  <div>
    <ul class="ul-box">
      <li><a href="javascript:;" @click="handleconfigToggle">配置</a></li>
      <li><a href="javascript:;" @click="handleRequestToggle">请求参数</a></li>
      <li>
        <a href="javascript:;" @click="handleResposeToggle">返回参数</a>
      </li>
      <li><a href="javascript:;" @click="handleVersionToggle">版本</a></li>
    </ul>
    <Drawer
      :mask="false"
      :transfer="false"
      :inner="true"
      :closable="true"
      title="配置"
      width="400"
      v-model="configToggle"
      class-name="drawer-custom"
    >
      <div class="clearfix item">
        <div class="float-right">
          <Button type="primary" :disabled="disabled" @click="clickSave"
            >保存</Button
          >
        </div>
      </div>
      <Form
        class="formInfo"
        ref="formInfo"
        :model="params.define"
        :rules="rule"
        :label-width="120"
        :disabled="disabled"
      >
        <FormItem label="API名称" prop="name">
          <Input v-model="params.define.name" />
        </FormItem>
        <FormItem label="API PATH" prop="url">
          <Input v-model="params.define.url" />
        </FormItem>
        <FormItem label="请求方式" prop="method">
          <Select v-model="params.define.method">
            <Option v-for="item in methods" :value="item" :key="item">{{
              item
            }}</Option>
          </Select>
        </FormItem>
        <FormItem label="详细描述" prop="desc">
          <Input
            v-model="params.define.desc"
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 5 }"
          ></Input>
        </FormItem>
      </Form>
    </Drawer>
    <!-- 请求参数 -->
    <Drawer
      :mask="false"
      :transfer="false"
      :inner="true"
      title="请求参数"
      width="650"
      v-model="requestToggle"
      class-name="drawer-custom"
    >
      <div class="clearfix item">
        <div class="float-right">
          <Button type="primary" :disabled="disabled" @click="clickSave"
            >保存</Button
          >
        </div>
      </div>
      <Table :columns="reqcolumns" :data="params.inputParameters">
        <template slot="type" slot-scope="{ index }">
          <Select
            size="small"
            v-model="params.inputParameters[index].type"
            style="width: 95px"
            transfer
            :disabled="disabled"
          >
            <Option value="string">String</Option>
            <Option value="bool">BOOL</Option>
            <Option value="number">NUMBER</Option>
            <Option value="array">ARRAY</Option>
          </Select>
        </template>
        <template slot="example" slot-scope="{ index }">
          <Input size="small" :disabled="disabled" v-model="params.inputParameters[index].example" />
        </template>
        <template slot="defaultValue" slot-scope="{ index }">
          <Input size="small" :disabled="disabled" v-model="params.inputParameters[index].defaultValue" />
        </template>
        <template slot="desc" slot-scope="{ index }">
          <Input size="small" :disabled="disabled" v-model="params.inputParameters[index].desc" />
        </template>
      </Table>
    </Drawer>
    <!-- 返回参数 -->
    <Drawer
      :mask="false"
      :transfer="false"
      :inner="true"
      title="返回参数"
      width="600"
      :scrollable="true"
      v-model="responseToggle"
      class-name="drawer-custom"
    >
      <div class="clearfix item">
        <Button
          class="float-right"
          type="primary"
          :disabled="disabled"
          @click="clickSave"
          >保存</Button
        >
      </div>
      <Table :columns="rescolumns" :data="params.outputParameters">
        <template slot="type" slot-scope="{ index }">
          <Select
            size="small"
            v-model="params.outputParameters[index].type"
            style="width: 95px"
            transfer
            :disabled="disabled"
          >
            <Option value="string">String</Option>
            <Option value="bool">BOOL</Option>
            <Option value="number">NUMBER</Option>
            <Option value="array">ARRAY</Option>
          </Select>
        </template>
        <template slot="desc" slot-scope="{ index }">
          <Input size="small" :disabled="disabled" v-model="params.outputParameters[index].desc" />
        </template>
      </Table>
    </Drawer>
    <!-- 版本 -->
    <Drawer
      :mask="false"
      :transfer="false"
      :inner="true"
      :scrollable="true"
      title="历史记录"
      width="400"
      v-model="versionToggle"
      class-name="drawer-custom"
    >
      <Table :columns="edcolumns" :data="params.historyVersion">
        <template slot-scope="{ row }" slot="desc">
          <a class="desc" href="javascript:void(0);" @click="showVersion(row)"
            >查看详情</a
          >
        </template>
      </Table>
    </Drawer>
    <Modal
      v-model="apiModal"
      title="版本详情"
      :mask-closable="false"
      width="860"
    >
      <Form ref="apiForm" :model="currentApiData" :label-width="80">
        <FormItem label="API名称" prop="name">
          <Input disabled v-model="currentApiData.name"></Input>
        </FormItem>
        <FormItem label="API PATH" prop="url">
          <Input disabled v-model="currentApiData.url"> </Input>
        </FormItem>
        <FormItem label="请求方式" prop="method">
          <Input disabled v-model="currentApiData.method" style="width: 200px">
          </Input>
        </FormItem>
        <FormItem label="请求参数">
          <Table :columns="reqcol" :data="currentApiData.reqdata"> </Table>
        </FormItem>
        <FormItem label="返回参数">
          <Table :columns="rescol" :data="currentApiData.resdata"></Table>
        </FormItem>
        <FormItem label="代码" prop="sql">
          <Input
            disabled
            v-model="currentApiData.sql"
            type="textarea"
            :rows="10"
          />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { methodList } from "@/api";
const methods = ["GET", "POST"];
const reqcol = [
  {
    title: "参数名",
    key: "name",
  },
  {
    title: "参数类型",
    key: "type",
  },
  {
    title: "示例",
    key: "example",
  },
  {
    title: "默认值",
    key: "defaultValue",
  },
  {
    title: "描述",
    key: "desc",
  },
];
const rescol = [
  {
    title: "参数名",
    key: "name",
  },
  {
    title: "参数类型",
    key: "type",
  },
  {
    title: "描述",
    key: "desc",
  },
];
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    params: Object,
    valideSQLFn: Function,
  },
  data() {
    return {
      configToggle: false,
      requestToggle: false,
      responseToggle: false,
      versionToggle: false,
      methods,
      reqcol,
      rescol,
      reqcolumns: [
        {
          title: "参数名",
          key: "name",
        },
        {
          title: "参数类型",
          key: "type",
          slot: "type",
        },
        {
          title: "示例",
          key: "example",
          slot: "example",
        },
        {
          title: "默认值",
          key: "defaultValue",
          slot: "defaultValue",
        },
        {
          title: "描述",
          key: "desc",
          slot: "desc",
        },
      ],
      rescolumns: [
        {
          title: "参数名",
          key: "name",
        },
        {
          title: "参数类型",
          key: "type",
          slot: "type",
        },
        {
          title: "描述",
          key: "desc",
          slot: "desc",
        },
      ],
      edcolumns: [
        {
          title: "版本",
          key: "version",
          align: "center",
        },
        {
          title: "详细信息",
          slot: "desc",
          align: "center",
        },
      ],
      rule: {
        name: [{ required: true, message: "请填写接口名称", trigger: "blur" }],
        url: [{ required: true, message: "请填写url", trigger: "blur" }]
      },
      apiModal: false,
      currentApiData: {
        name: "",
        url: "",
        method: "",
        sql: "",
        reqdata: [],
        resdata: [],
      },
    };
  },
  methods: {
    handleconfigToggle() {
      this.configToggle = true;
    },
    handleRequestToggle() {
      this.valideSQLFn((status) => {
        if (status) {
          this.requestToggle = true;
        }
      });
    },
    handleResposeToggle() {
      this.valideSQLFn((status) => {
        if (status) {
          this.responseToggle = true;
        }
      });
    },
    handleVersionToggle() {
      this.versionToggle = true;
    },
    clickSave(type,cb) {
      this.$refs["formInfo"].validate((valid) => {
        if (valid) {
          this.configToggle && (this.configToggle = false);
          this.$emit("handleSave",type,cb);
        } else {
          !this.configToggle && (this.configToggle = true);
        }
      });
    },
    showVersion(row) {
      let content = row.source && JSON.parse(row.source);
      if (content) {
        let { url, method, script:sql, name } = content.define || {};
        let { inputParameters, outputParameters } = content || {};
        this.currentApiData = {
          name,
          url,
          sql,
          method: this.getConextFromNum(method),
          reqdata: inputParameters || [],
          resdata: outputParameters || [],
        };
        this.apiModal = true;
      }
    },
    getConextFromNum(value) {
      let method = "";
      for (let i = 0; i < methodList.length; i++) {
        let b = 1 << i;
        if ((value & b) == b) {
          method = methodList[i];
        }
      }
      return method;
    },
  },
};
</script>
<style scoped>
.ul-box {
  padding-top: 65px;
  height: 100%;
  position: relative;
  z-index: 200;
}
.ul-box > li {
  width: 20px;
  margin: 0 auto;
  line-height: 24px;
  font-size: 20px;
  margin-bottom: 20px;
}
.desc {
  color: #2d8cf0;
}
</style>
<style>
.drawer-custom {
  top: 124px;
  position: fixed;
  z-index: 200;
}
</style>